import i18next from 'i18next';
import { ECourseColumns, filterableColumns } from '../../store/store';
import get from 'lodash/get';
import keys from 'lodash/keys';
var compareFunc = new Intl.Collator('de', { numeric: true, sensitivity: 'accent' }).compare;
export var sortAlphaNum = function (key) { return function (a, b) { return compareFunc(key ? get(a, key) : a, key ? get(b, key) : b); }; };
export var getColumnHeadersLabels = function () {
    var _a;
    return (_a = {},
        _a[ECourseColumns.COURSE] = i18next.t('course_table.event'),
        _a[ECourseColumns.PLACE] = i18next.t('course_table.places'),
        _a[ECourseColumns.FROM] = i18next.t('course_table.from'),
        _a[ECourseColumns.TO] = i18next.t('course_table.to'),
        _a[ECourseColumns.INFO] = i18next.t('course_table.information'),
        _a[ECourseColumns.REMAINING] = i18next.t('course_table.remaining'),
        _a[ECourseColumns.TRAINER] = i18next.t('course_table.trainer'),
        _a[ECourseColumns.APPOINTMENTS] = i18next.t('course_table.appointments'),
        _a[ECourseColumns.APPOINTMENT_LIST] = i18next.t('course_table.appointment_list'),
        _a[ECourseColumns.PRICE] = i18next.t('course_table.price'),
        _a[ECourseColumns.DESCRIPTION] = '',
        _a);
};
var getAllAvailableColumnNames = function () {
    return [
        ECourseColumns.COURSE,
        ECourseColumns.PLACE,
        ECourseColumns.FROM,
        ECourseColumns.TO,
        ECourseColumns.PRICE,
        ECourseColumns.INFO,
        ECourseColumns.TRAINER,
        ECourseColumns.APPOINTMENTS,
        ECourseColumns.APPOINTMENT_LIST,
        ECourseColumns.REMAINING,
        ECourseColumns.DESCRIPTION,
        ECourseColumns.BOOKLINK,
    ];
};
export var getDefaultAvailableColumns = function () {
    var droppedColumns = [ECourseColumns.PRICE,
        ECourseColumns.APPOINTMENTS,
        ECourseColumns.TRAINER,
        ECourseColumns.APPOINTMENTS,
        ECourseColumns.APPOINTMENT_LIST,
    ];
    return getAllAvailableColumnNames().filter(function (column) { return !droppedColumns.includes(column); });
};
export var getDisplayColumns = function (columns) {
    var availableColumns = getDefaultAvailableColumns();
    return columns.length === 0 ? availableColumns : columns;
};
export var getFilterColumns = function (columns, disabledFilters) {
    if (columns === void 0) { columns = getAllAvailableColumnNames(); }
    var disabledFiltersArray = keys(disabledFilters).map(function (filter) { return filter.replace('disablefilter_', ''); });
    var filteredFilterableColumns = filterableColumns.filter(function (column) {
        return !(disabledFilters.hasOwnProperty('disablefilters') || disabledFiltersArray.includes(column));
    });
    return columns.length === 0
        ? filteredFilterableColumns
        : columns.filter(function (column) { return filteredFilterableColumns.includes(column); });
};
export var getColumnHeaders = function (columns, fixedColumns, records) {
    var columnHeadersLabels = getColumnHeadersLabels();
    var flexibleColumns = [ECourseColumns.COURSE, ECourseColumns.PLACE, ECourseColumns.TRAINER];
    // const fixedColumns = [ECourseColumns.TO, ECourseColumns.PRICE, ECourseColumns.INFO];
    var availableColumns = columns.reduce(function (availableColumns, key, i, self) {
        var compareValues = function (arr, obj) {
            switch (key) {
                case ECourseColumns.TRAINER:
                    return arr[0][key].map(function (x) { return x.id; }).join(",") !== obj[key].map(function (x) { return x.id; }).join(",");
                case ECourseColumns.APPOINTMENTS:
                    return [].concat(arr[0][key]).join(",") !== [].concat(obj[key]).join(",");
                case ECourseColumns.APPOINTMENT_LIST:
                    return [].concat(arr[0][key]).join(",") !== [].concat(obj[key]).join(",");
                default:
                    return arr[0][key] !== obj[key];
            }
        };
        if (records.some(function (record, i, self) {
            if (fixedColumns.includes(key))
                return true;
            var fixedColumnValue = !flexibleColumns.includes(key) && record[key];
            return self.length > 1 ? i > 0 && (fixedColumnValue || compareValues(self, record)) : fixedColumnValue;
        })) {
            availableColumns.push({ key: key, label: columnHeadersLabels[key] });
        }
        return availableColumns;
    }, []);
    return availableColumns;
};
